import { ConnectedProps, connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import FoundationLogo from "../../assets/images/FoundationLogo.png";
import Logo from "../../assets/images/MarkLogo.png";
import Footer from "../../components/Footer/Footer";
import { RootState } from "../../stores/AppReducers";
import GlobalLoadingActions from "../../stores/GlobalLoading/Actions";
import { StyledButtonOutlined } from "../../theme/Styles";
import {
  ButtonsContainer,
  Container,
  FormContainer,
  FoundationLogosContainer,
  LogoImage,
  MinLogo,
  RightContainer,
  WhiteLine,
} from "./styles/WelcomeStyles";

import SoldOutModal from "../../components/SoldOutModal";

function Welcome(props: ScreenProps) {
  let navigate = useNavigate();

  const handlerNavigate = (route: string) => {
    navigate(route);
  };

  return (
    <Container>
      <RightContainer>
        <LogoImage src={Logo} />
        <FormContainer>
          {/* Sold Out Dialog Modal */}
          <SoldOutModal />
          <br />
          <br />
          <h2>
            ¡Únete a nosotros en nuestro tercer clásico de golf benéfico! 
          </h2>
          <br />
          <WhiteLine />
          <h3>Corales Golf Course Punta Cana</h3>
          <WhiteLine />
          <br />
          <h1>3er Clásico de Golf Fundación IQtek </h1>
          <br />
          <h3>
            Completa este formulario para participar y apoyar a la Fundación Yo
            Tambien Puedo.
          </h3>
          <ButtonsContainer>
            <StyledButtonOutlined onClick={() => handlerNavigate("/payment")}>
              Proceder al Pago
            </StyledButtonOutlined>

            <StyledButtonOutlined
              onClick={() => handlerNavigate("/register-sponsored")}
            >
              Registro de Jugadores Patrocinados
            </StyledButtonOutlined>
          </ButtonsContainer>

          <br />
          <h3>
            <strong>
               Viernes 12 de Junio del 2026 <br/> Torneo Pro am <br/> US$ 500.00 P/P
            </strong>
            <WhiteLine />
            <br/>
             <strong>
               Sabado 13 de Junio del 2026 <br/> 3er Torneo de Golf <br/> US$ 500.00 P/P
            </strong>
            <WhiteLine />
          </h3>
          <p style={{ color: "white" }}>A beneficio :</p>
          <FoundationLogosContainer>
            <MinLogo src={FoundationLogo} />
          </FoundationLogosContainer>
        </FormContainer>
      </RightContainer>
      <Footer />
    </Container>
  );
}

interface ScreenProps extends ReduxProps {}

const mapStateToProps = (state: RootState) => ({
  user: state.signin.user,
});

const mapDispatchToProps = {
  showGlobalLoading: GlobalLoadingActions.showGlobalLoading,
  hideGlobalLoading: GlobalLoadingActions.hideGlobalLoading,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(Welcome);
